var map = {
	"./cnc-processing.png": "SvJ0",
	"./die-casting.png": "uyhR",
	"./lost-wax-casting.png": "lWIp",
	"./metal-forging.png": "9iWD",
	"./special.png": "T7DK",
	"./spinning.png": "t6l/",
	"./stamping-press.png": "XzP7",
	"./surface-treatment.png": "a7o3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uku6";